// extracted by mini-css-extract-plugin
export default {"root":"McpFunDrawer_root__mehPr"};